export function generateRandomCode(length: number) {
  const chars = "023456789ABCDEFGHJKMNOPQRSTUVWXYZ";
  let result = "";
  for (let i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
}
